import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const CustomerFarmsView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});

  let customer_id = localStorage.getItem("customer_id");
  useEffect(() => {
    axios
      .get(`/customerportal/farmers/listings/view/${id+'-'+customer_id}`, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.farmer);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(value);

  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }
  const viewQualityFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Farm View</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                    <Link to="/customerportal/profile">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/farms">
                      Farms
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Farm
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Farm Details</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Name</th>
                        <td className="p-3">
                          {value.name}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">GPS Location</th>
                        <td className="p-3">
                          {value.location}
                        </td>
                      </tr>
                   
                      <tr>
                        <th className="p-3">GGN Number</th>
                        <td className="p-3">
                          {value.ggn_number}
                        </td>
                      </tr>
                         </table>
                    <br />
                    <h5 className="card-title">Farm Certificates</h5>

                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">File Name</th>
                        <th className="p-3">File Type</th>
                        <th className="p-3">File Link</th>
                        <th className="p-3">File Extension</th>
                        <th className="p-3">Expire Date</th>
                        <th className="p-3">Note</th>
                      </tr>
                      {value.allfiles &&
                        value.allfiles.map((item, indx) => (
                          <tr  key={item.file_name || indx}>
                            <td className="p-3">{item.file_name}</td>
                            <td className="p-3">{item.file_type_name}</td>
                            <td className="p-3">
                              {item.link  && (
                                <a
                                className="btn btn-link"
                                href={viewFile(item.link) }
                                target="_blank"
                              
                                rel="noreferrer" 
                              >
                                Download
                              </a>
                              ) }
                              
                            </td>
                            <td className="p-3">{item.extension}</td>
                            <td className="p-3">{item.expiry_date}</td>
                            <td className="p-3">{item.note}</td>
                          </tr>
                        ))}
                    </table>
                   
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                   
                    <h5 className="card-title">Lab Analysis</h5>

                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Date</th>
                        <th className="p-3">Analysis name</th>
                        <th className="p-3">Lab Name</th>
                        <th className="p-3">Product Name</th>
                        <th className="p-3">Farm</th>
                        <th className="p-3">File</th>
                      </tr>
                      {value.qualities &&
                        value.qualities.map((item, indx) => (
                          <tr  key={indx }>
                            <td className="p-3">{item.date}</td>
                            <td className="p-3">{item.analysis_name}</td>
                            <td className="p-3">{item.lab_name}</td>
                            <td className="p-3">{(item.product_details)?item.product_details.productname:""}</td>
                            <td className="p-3">{(item.farm_detail)?item.farm_detail.name:""}</td>
                            <td className="p-3">
                              {item.file  && (
                                <a
                                className="btn btn-link"
                                href={viewQualityFile(item.file) }
                                target="_blank"
                              
                                rel="noreferrer" 
                              >
                                Download
                              </a>
                              ) }
                              
                            </td>
                           
                          </tr>
                        ))}
                    </table>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerFarmsView;
